export function isMacOS(): boolean {
    if (typeof navigator === "undefined") return false;
    const platform = navigator.platform || navigator.userAgent || "";
    return /Mac|iPod|iPhone|iPad/i.test(platform);
}
